export default __webpack_public_path__ + "static/media/bm-4.2a63455a.png";